import { CustomFieldsMetaData } from './customfieldsmetadata';
export class CustomFields {
    public candidateCustomData = {};
    public candidateCustomMetaData: CustomFieldsMetaData[] = [];
}
